class FormPage {
    public id: string;
    public name: string;
    public render: () => JSX.Element;

    constructor(fields?: Partial<FormPage>) {
        Object.assign(this, fields);
    }
}

export { FormPage };
